import { getSpecs } from '../options';
import { useCurrency } from './useCurrency';
import { useContact } from './useContact';
import { useContactPersons } from './useContactPersons';
import { useDate } from './useDate';
import { useAddresses } from './useAddress';
import { useAccount } from './useAccount';
import { useShowShipping } from './useShowShipping';
import { usePaymentMethod } from './usePaymentMethod';
import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

const selectorFn = state => ({
    companyCountryCode: state.Auth.companyCountryCode,
    companyCurrencyCode: state.Auth.companyCurrencyCode,
    currencyCode: state.Transaction.currencyCode,
    instructionTransactionType: state.Instruction.transactionType,
});

export function useTransactionEffects(props, form) {
    const { isRecurring, transactionType: propTransactionType } = props;

    const {
        companyCurrencyCode,
        companyCountryCode,
        currencyCode,
        instructionTransactionType,
    } = useSelector(selectorFn, shallowEqual);

    const transactionType = useMemo(() => (
        isRecurring ? instructionTransactionType : propTransactionType
    ), [
        instructionTransactionType,
        isRecurring,
        propTransactionType,
    ]);

    const specs = useMemo(() => getSpecs(transactionType), [transactionType]);
    const isHomeCurrency = useMemo(() => (
        companyCurrencyCode && companyCurrencyCode === currencyCode
    ), [companyCurrencyCode, currencyCode]);

    const isMalaysianCompany = companyCountryCode === 'MY';

    const {
        readExchangeRate,
        onExchangeRateChange,
        onCurrencyCodeChange,
        currencyCodeChanged,
    } = useCurrency({ form, isRecurring });

    const {
        onDateChange,
    } = useDate({ form, isRecurring, transactionType }, readExchangeRate);

    const {
        readAddresses,
        onLocationChange,
    } = useAddresses({ form, specs, transactionType });

    const {
        readContactPersons,
    } = useContactPersons({ form, specs, transactionType });

    const {
        onContactIdChange,
        onContactCreate,
        onContactUpdate,
    } = useContact({ form, specs, isRecurring, transactionType, isMalaysianCompany },
        readAddresses,
        currencyCodeChanged,
        readContactPersons);

    const {
        onAccountCreate,
        onAccount2Create,
    } = useAccount({ form });

    const {
        onShowShippingChange,
    } = useShowShipping({ form, specs });

    const {
        onPaymentMethodCreate,
    } = usePaymentMethod({ form, transactionType });

    return {
        isHomeCurrency,
        form,
        onContactIdChange,
        onContactCreate,
        onContactUpdate,
        onAccountCreate,
        onAccount2Create,
        onDateChange,
        onCurrencyCodeChange,
        currencyCodeChanged,
        onExchangeRateChange,
        onShowShippingChange,
        onPaymentMethodCreate,
        onLocationChange,
    };
}
